import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User } from '../../../class/user';
import { UserService } from '../../../service/user/user.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: User;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public password: AbstractControl;
    public password_confirmation: AbstractControl;
    public email: AbstractControl;
    public role_id: AbstractControl;
    public employee_id: AbstractControl;
    public employeeSelected: string;

    public password_change_at: AbstractControl;

    public activated: AbstractControl;

    public optionsRoles: any[];
    public companies: AbstractControl;

    @ViewChild('search') public searchElementRef: ElementRef;
    public zoom: number;
    public marker: Marker;

    public filteredCurrencies: any[];
    public filteredTimezones: any[];

    public save_exit: boolean;

    fieldTextType: boolean = false;

    public es: any;

    constructor(
        fb: FormBuilder,
        public userService: UserService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader,
        public hasPermissionService: HasPermissionService,
    ) {

        this.save_exit = false;

        this.es = calendarES();

        this.getUserRoles();

        this.form = fb.group({
            'password': ['', Validators.compose([ Validators.minLength(2) ]) ],
            'password_confirmation': ['', Validators.compose([ Validators.minLength(2) ]) ],
            'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ]) ],
            'activated': ['', Validators.compose([ Validators.required ]) ],
            'role_id': ['', Validators.compose([ Validators.required ]) ],
            'employee_id': [''],
            // 'employee_id': ['', Validators.compose([Validators.required])],
            'companies': [''],
            'password_change_at': [''],
        });

        this.email = this.form.controls['email'];
        this.activated = this.form.controls['activated'];
        this.password = this.form.controls['password'];
        this.password_confirmation = this.form.controls['password_confirmation'];
        this.role_id = this.form.controls['role_id'];
        this.employee_id = this.form.controls['employee_id'];
        this.companies = this.form.controls['companies'];
        this.password_change_at = this.form.controls['password_change_at'];
    }

    ngOnInit() {
        if (this.edit) {
            this.email.setValue(this.edit.email);
            this.activated.setValue(this.edit.activated);
            this.password.setValue(this.edit.password);
            this.password_confirmation.setValue(this.edit.password_confirmation);
            if (this.edit.roles.length > 0) {
                this.role_id.setValue(this.edit.roles[0].name);
            }
            this.employee_id.setValue(this.edit.employee_id);
            this.companies.setValue(this.edit.companies);

            if (this.edit.password_change_at)
                this.password_change_at.setValue(new Date(this.edit.password_change_at));

            // if(this.edit.roles[0].id == 3)
            //     this.form.get('role_id').disable();

            // if (this.edit.roles[0].id != 3)
            //     this.form.get('employee_id').setValidators([Validators.required]);
            
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelUser () {
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newUser(values);
    }

    public newUser(values: any) {
        var companies = [];
        if (values.companies) {
            values.companies.forEach(element => {
                if(element.value)
                    companies.push(element.value);
                if(element.id)
                    companies.push(element.id);    
            });
        }

        var limDays = 80;
        if (values.password_change_at == null || values.password_change_at == '')
            values.password_change_at = formatDate(this.getDatePassword(limDays));
        else {
            var difDays = this.getDiffDateToday(values.password_change_at);
            if (difDays <= limDays)
                values.password_change_at = formatDate(values.password_change_at);
            else
                values.password_change_at = formatDate(this.getDatePassword(limDays));
        }

        const param = {
            'email': values.email,
            'password': values.password,
            'password_confirmation': values.password_confirmation,
            'activated': values.activated,
            'employee_id': (values.role_id == "Candidate") ? null : values.employee_id,
            'role': values.role_id,
            'companies': (values.role_id == "Candidate") ? null : companies,
            'password_change_at': (values.role_id == "Candidate") ? null : (values.password_change_at == '' || values.password_change_at == null) ? null : values.password_change_at,
        };

        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.userService.updateUser(this.edit.id, param)
                :
                this.userService.newUser(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    getUserRoles() {
        this.optionsRoles = [];
        this.optionsRoles.push ({key: 'administrator', value: 'administrator'});
        this.optionsRoles.push ({key: 'user', value: 'user'});
    //     this.optionsTypes = [];
    //     this.userRolesService.getUserRoles().toPromise().then(
    //         response => {
    //             response.json().data.forEach(element => {
    //                 this.optionsTypes.push({'label': element.name, 'value': element.id});
    //             });
    //         },
    //         error => {
    //             console.log('error getting roles:' + error);
    //         }
    //     );
    }

    getDiffDateToday(date_start) {
        let dateStart = new Date(date_start);
        let dateEnd = new Date();
        
        const diff = dateEnd.getTime() - dateStart.getTime();
        return Math.ceil(diff / (1000 * 3600 * 24));
    }

    getDatePassword(limDays) {
        var passwordDay = new Date();
        passwordDay.setDate(passwordDay.getDate() - limDays);

        return passwordDay;
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public getStatus(event, name: string){
        // console.log("El pinche rol es: " + event)
        var status = false;
        if (event != name)
            status = true;
        return status;
    }

    toggleFieldTextType(field_password: number) {
        if(field_password == 1)
            this.fieldTextType = !this.fieldTextType;
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/users/new-user/new-user.component.ts